import { invokeApi } from "../../utils/invokeApi/invokeApi";

export const get_combined_podcast_data = async (
  source_slug,
  feature_slug,
  page = 0,
  limit = 50
) => {
  const requestObj = {
    path: `api/podcast_category/combined_data/${source_slug}/${feature_slug}?page=${page}&limit=${limit}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const podcast_against_category = async (
  category_slug,
  search,
  source_slug,
  feature_slug
) => {
  const requestObj = {
    path: `api/podcast_blog/get_podcast_blog_by_podcast_category_slug?category_slug=${category_slug}&search=${search}&source_slug=${
      source_slug || ""
    }&feature_slug=${feature_slug || ""}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_podcasts_listing = async (
  source_slug,
  feature_slug,
  search = "",
  category_slug = "",
  page = 0,
  limit = 20
) => {
  const requestObj = {
    path: `api/podcast_blog/get_podcast_blog_for_client?source_slug=${source_slug}&feature_slug=${feature_slug}&name=${encodeURIComponent(
      search
    )}&page=${page}&limit=${limit}&category_slug=${category_slug}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const podcast_details = async (slug) => {
  const requestObj = {
    path: `api/podcast_blog/detail_podcast_blog/${slug}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const podcast_play_count_increase = async (id) => {
  const requestObj = {
    path: `api/podcast_blog/poadcast_play_count/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_Active_podcast_Categories = async (
  source_slug = "",
  featureSlug = "",
  page = 0,
  limmit = 100,
  search = ""
) => {
  const requestObj = {
    path: `api/podcast_category/active_podcast_category?feature_slug=${featureSlug}?limit=${limmit}&page=${page}&search=${search}&source_slug=${source_slug}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
